import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLprFilterCamera extends SnModel {
  @Expose()
  public models: string[];

  @Expose()
  public vendors: string[];

  constructor(data = {}) {
    super();
    this.fromJSON(data);
  }
}
